import { render } from "./menu2.vue?vue&type=template&id=0a96eaa8&scoped=true"
import script from "./menu2.vue?vue&type=script&lang=js"
export * from "./menu2.vue?vue&type=script&lang=js"

import "./menu2.vue?vue&type=style&index=0&id=0a96eaa8&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a96eaa8"]])

export default __exports__